const ConsumerErrorCategory = {
    UNKNOWN: '00',
    PLAYBACK_INTERRUPTED_CONNECTION_LOST: '10',
    PLAYBACK_SOURCE: '11',
    API_SERVICE_PLAYBACK: '65',
};

export default ConsumerErrorCategory;
